import { Routes, Route, Navigate } from 'react-router-dom'
import Login from '../page/Login'
import FindPassword from '../page/FindPassword'
import AlgoTest from '../page/AlgoTest'
import AlgoTestSell from '../page/AlgoTestSell'
import { RequireAuthWrapper } from '../components/RequireAuth'

import {
  CustomerLoad,
  CustomerPV,
  DataElectricity,
  DataHoliday,
  DataKepco,
  DataMonthlySMP,
  DataPV,
  DataREC,
  DataSMP,
  DataUnit,
  EconomicCapacity,
  EconomicESS,
  EconomicPV,
  Home,
  PurchasePlans,
  PurchasePlansCheck,
  SalesPlanCheck,
  SellPlans,
} from '../page'
import CustomerESS from '../page/CustomerESS'

export default function MainRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/" element={<Login />} />
      <Route path="/findpassword" element={<FindPassword />} />
      <Route
        path="/home"
        element={
          <RequireAuthWrapper permission="user">
            <Home />
          </RequireAuthWrapper>
        }
      >
        <Route
          path="/home"
          element={<Navigate to="/home/economic-ess" replace />}
        />
        <Route path="customer-pv" element={<CustomerPV />} />
        <Route path="customer-load" element={<CustomerLoad />} />
        <Route path="customer-ess" element={<CustomerESS />} />
        <Route path="electricity-purchase-plans" element={<PurchasePlans />} />
        <Route
          path="electricity-purchase-plans-check"
          element={<PurchasePlansCheck />}
        />

        <Route path="electricity-sell-plans" element={<SellPlans />} />
        <Route
          path="electricity-sell-plans-check"
          element={<SalesPlanCheck />}
        />
        <Route path="economic-pv" element={<EconomicPV />} />
        <Route path="economic-capacity" element={<EconomicCapacity />} />
        <Route path="economic-ess" element={<EconomicESS />} />
        <Route path="data-unit" element={<DataUnit />} />
        <Route path="data-smp" element={<DataSMP />} />
        <Route path="data-monthly-weighted-smp" element={<DataMonthlySMP />} />
        <Route path="data-pv" element={<DataPV />} />
        <Route path="data-electricity" element={<DataElectricity />} />
        <Route path="data-kepco-tariffs" element={<DataKepco />} />
        <Route path="data-holiday" element={<DataHoliday />} />
        <Route path="data-rec" element={<DataREC />} />
        <Route path="algo" element={<AlgoTest />} />
        <Route path="algo-sell" element={<AlgoTestSell />} />
      </Route>
    </Routes>
  )
}
